

import React, { useState, useEffect, useContext } from 'react';
import ReportService from "../../controller/ReportController/ReportController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateReport from './CreateReport';
import HelpSite from "../../../Common/HelpLink";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSiteService from "../../../SuperAdmin/Controller/Configuration/HelpSiteController";
function IndustrySectorListPage() {
    const navigate = useNavigate();
    const [ReportList, setReportList] = useState([]);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [modalInstance, setModalInstance] = useState(null);
    const [currentReport, setCurrentReport] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const fetchReports = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const reportList = await ReportService.GetJasperReport(redirectCallback);
            setReportList(reportList);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };


    useEffect(() => {
        fetchReports();
    }, []);

    const handleCreateReportClick = () => {
        setCurrentReport(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {

        setIsModalOpen(false);
    };
    const handleSuccess = () => {
        fetchReports();
        setIsModalOpen(false);
    };
    const handleEditClick = (jobRole) => {
        setCurrentReport(jobRole); // Set the team to be edited
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation();
        Swal.fire({
            title: 'Are you sure?',
            text: `Are you sure you want to delete`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await ReportService.DeleteJasperReport(ID);
                    fetchReports();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting Industry Sector:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });



    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>

            <div className="row mb-3">

                <div className="col-sm-3">

                    <Link className='btn btn-primary btn-sm' onClick={handleCreateReportClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Depots" Module="26" />
                </div>
            </div>
            <table className="table m-0 table-hover">
                <thead>
                    <tr>

                        <th>Report Name</th>
                        <th>Description</th>
                        <th>Link</th>
                        <th>Company Name</th>
                        <th>Module</th>
                        <th>Default</th>
                        <th style={{ "textAlign": "right" }}></th>
                    </tr>
                </thead><tbody>

                    {ReportList.map((report, index) => (

                        <tr key={report.ID} onClick={() => handleEditClick(report)}>

                            <td>{report.ReportTitle}</td>
                            <td>{report.Description}</td>
                            <td>{report.Link}</td>
                            <td>{report.CompanyName}</td>
                            <td>{report.vc_ModuleName}</td>
                            <td>{report.Default}</td>
                            <td style={{ "textAlign": "right" }}>

                                <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={(event) => handleDeleteClick(event, report.ID)}>
                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {(isModalOpen &&
                <CreateReport currentReport={currentReport} onClose={handleCloseModal} onSuccess={handleSuccess} />
            )}
        </div>
    );
}

export default IndustrySectorListPage;